import { keepPreviousData, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import useTomoUserInfo from './useTomoUserInfo';
import { BTCNetworkType } from '../api/type';
import { btcAddressTypeMaps } from '../config/btc';

export const getBalanceFromNode = async (
  address: string | undefined,
  rpc: string
) => {
  const res = await axios.get(`${rpc}/api/address/${address}/utxo`, {
    maxRedirects: 1,
  });

  return res.data;
};

const useBTCBalance = (netWorkType: BTCNetworkType = 'MAINNET') => {
  const { btcAddress } = useTomoUserInfo();

  const getByAddressBalance = async (address: string | undefined) => {
    const rpc =
      netWorkType === 'MAINNET'
        ? 'https://btc-rpc.lorenzo-protocol.xyz'
        : 'https://btc-rpc-signet.lorenzo-protocol.xyz/signet';
    if (!address) return 0;
    const btcRes = await getBalanceFromNode(address, rpc);
    if (btcRes && btcRes.length > 0) {
      return btcRes[0].value;
    }
    return 0;
  };

  return useQuery({
    queryKey: ['BTCBalances', btcAddress],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      try {
        const data = await Promise.all(
          btcAddressTypeMaps.map(async typeKey => {
            // @ts-ignore
            const address = btcAddress[`${typeKey}Address`] as
              | string
              | undefined;
            const value = await getByAddressBalance(address);

            return {
              value,
              address,
              type: typeKey,
            };
          })
        );
        return data;
      } catch (error) {
        console.warn(error);
      }
      return null;
    },
  });
};

export default useBTCBalance;
